// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SwitchMenuItem__container-b00dc9 {
  --menu-item-side-offset: 16px;
  --menu-item-vertical-offset: 0;
  min-height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--menu-item-vertical-offset) var(--menu-item-side-offset);
  box-sizing: border-box;
  color: var(--base-110);
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
}

.SwitchMenuItem__container-b00dc9:hover,
.SwitchMenuItem__container-b00dc9:focus-visible {
  background-color: var(--base-17);
}

.SwitchMenuItem__container-b00dc9:active {
  background-color: var(--base-20);
}

.SwitchMenuItem__icon-abef77 {
  width: 24px;
  text-align: center;
  margin-inline-end: 16px;
  display: flex;
  align-items: center;
  color: var(--base-80);
}

.SwitchMenuItem__icon-abef77 svg {
  fill: currentColor;
}

.SwitchMenuItem__title-fcc183 {
  display: block;
  margin-inline-end: 16px;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: currentColor;
}

.SwitchMenuItem__title-suffix-b8f285 {
  margin-inline-start: 5px;
}

.SwitchMenuItem__subtitle-ac4105 {
  display: block;
  margin-inline-end: 16px;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.SwitchMenuItem__switch-a02305 {
  margin-inline-start: auto;
  flex-shrink: 0;
}

/* dark theme (call panel) */
.SwitchMenuItem__container--dark-de768e,
.SwitchMenuItem__container--dark-de768e .SwitchMenuItem__icon-abef77 {
  color: var(--addition-50);
}

.SwitchMenuItem__container--dark-de768e:hover,
.SwitchMenuItem__container--dark-de768e:focus-visible {
  background-color: var(--addition-50_10);
}

.SwitchMenuItem__container--dark-de768e:active {
  background-color: var(--addition-50_20);
}

/* danger theme (delete button) */
.SwitchMenuItem__container--danger-b249f5,
.SwitchMenuItem__container--danger-b249f5 .SwitchMenuItem__icon-abef77 {
  color: var(--brand-primary-40);
}

.SwitchMenuItem__small-1-size-e58b16 {
  --menu-item-vertical-offset: 12px;
  --menu-item-side-offset: 24px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/SwitchMenuItem/SwitchMenuItem.m.css"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,8BAAA;EAEA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sEAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAGA;;EAEE,gCAAA;AAAF;;AAGA;EACE,gCAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,0CAAA;EACA,mBAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE,cAAA;EACA,uBAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;AAAF;;AAGA,4BAAA;AAEA;;EAEE,yBAAA;AADF;;AAIA;;EAEE,uCAAA;AADF;;AAIA;EACE,uCAAA;AADF;;AAIA,iCAAA;AAEA;;EAEE,8BAAA;AAFF;;AAKA;EACE,iCAAA;EACA,6BAAA;AAFF","sourcesContent":[".container {\n  --menu-item-side-offset: 16px;\n  --menu-item-vertical-offset: 0;\n\n  min-height: 40px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: var(--menu-item-vertical-offset) var(--menu-item-side-offset);\n  box-sizing: border-box;\n  color: var(--base-110);\n  cursor: pointer;\n  user-select: none;\n  flex-shrink: 0;\n}\n\n.container:hover,\n.container:focus-visible {\n  background-color: var(--base-17);\n}\n\n.container:active {\n  background-color: var(--base-20);\n}\n\n.icon {\n  width: 24px;\n  text-align: center;\n  margin-inline-end: 16px;\n  display: flex;\n  align-items: center;\n  color: var(--base-80);\n}\n\n.icon svg {\n  fill: currentColor;\n}\n\n.title {\n  display: block;\n  margin-inline-end: 16px;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: currentColor;\n}\n\n.title-suffix {\n  margin-inline-start: 5px;\n}\n\n.subtitle {\n  display: block;\n  margin-inline-end: 16px;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.switch {\n  margin-inline-start: auto;\n  flex-shrink: 0;\n}\n\n/* dark theme (call panel) */\n\n.container--dark,\n.container--dark .icon {\n  color: var(--addition-50);\n}\n\n.container--dark:hover,\n.container--dark:focus-visible {\n  background-color: var(--addition-50_10);\n}\n\n.container--dark:active {\n  background-color: var(--addition-50_20);\n}\n\n/* danger theme (delete button) */\n\n.container--danger,\n.container--danger .icon {\n  color: var(--brand-primary-40);\n}\n\n.small-1-size {\n  --menu-item-vertical-offset: 12px;\n  --menu-item-side-offset: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SwitchMenuItem__container-b00dc9`,
	"icon": `SwitchMenuItem__icon-abef77`,
	"title": `SwitchMenuItem__title-fcc183`,
	"title-suffix": `SwitchMenuItem__title-suffix-b8f285`,
	"titleSuffix": `SwitchMenuItem__title-suffix-b8f285`,
	"subtitle": `SwitchMenuItem__subtitle-ac4105`,
	"switch": `SwitchMenuItem__switch-a02305`,
	"container--dark": `SwitchMenuItem__container--dark-de768e`,
	"containerDark": `SwitchMenuItem__container--dark-de768e`,
	"container--danger": `SwitchMenuItem__container--danger-b249f5`,
	"containerDanger": `SwitchMenuItem__container--danger-b249f5`,
	"small-1-size": `SwitchMenuItem__small-1-size-e58b16`,
	"small1Size": `SwitchMenuItem__small-1-size-e58b16`
};
module.exports = ___CSS_LOADER_EXPORT___;
